<div class="row" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/user-dashboard'">
      <i class="fas fa-fw fa-home me-2"></i>Home<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>

    <span class="c_bluedk"><i class="fas fa-fw fa-file-invoice-dollar mx-2"></i>Billing Center</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header">
        <i class="fas fa-hammer me-2"></i>
        Billing Tools
      </div>
      <div class="card-body">
        <div class="mb-3">
          <a [routerLink]="'/admin/billing-generator'" class="bolder"><i class="fas fa-fw fa-print me-2"></i>Bill Generation Tool</a>
          <div class="my-2">
            Use this tool to generate bills for selected clients for a provided date range.  This generates deliverable bills as PDF and saves them to Welara's Google Drive instance.
          </div>
        </div>
        <div class="mb-3">
          <a [routerLink]="'/admin/billing-configuration'" class="bolder"><i class="fas fa-fw fa-cog me-2"></i>Bill Configuration Tool</a>
          <div class="my-2">
            Use this tool to configure billing settings for each client, including no-bill status and which sections to include in the invoice.
          </div>
        </div>
        <div class="mb-3">
          <a [routerLink]="'/excel-upload'" class="bolder"><i class="fas fa-fw fa-file-excel me-2"></i>Data Manager</a>
          <div class="my-2">
            Use this tool to manage billing data files, such as AUM data, from Excel.
          </div>
        </div>
        <div class="mb-3">
          <a [routerLink]="'/admin/billing-review-pivot-grid'" class="bolder"><i class="fas fa-fw fa-filter me-2"></i>Billing Review Pivot Grid</a>
          <div class="my-2">
            Use this tool to review Hourglass client data pivoted by month/task.
          </div>
        </div>
        <div class="">
          <a href="https://reporting.welara.com/hourglass_export_resource.aspx" class="bolder" target="_blank">
            <i class="fas fa-fw fa-file-pdf me-2"></i>Hourglass Client/Resource Billing Report</a>
          <div class="my-2">
            Review this report to see detailed billing data by client and resource, which can help identify any discrepancies or issues prior to bill generation.
          </div>
        </div>
</div>
    </div>
  </div>
<div class="col-12 col-md-8">
  <app-billing-qb-refresh [isInline]="true"></app-billing-qb-refresh>
</div>
</div>



<!-- MODAL markup -->
<div class="backdrop" data-bs-backdrop="true" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="billingModal">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid p-0">
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 p-0 modal-title"></div>
            <div class="col-12 col-md-6 p-0 text-end">
              <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="modal-body">

      </div>
      <div class="modal-footer text-center d-none">
        <button type="button" class="btn btn-dark my-1" title="Save">
          <i class="fas fa-fw fa-save"></i>
        </button>
        <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
          <i class="fas fa-fw fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
